export const MaintenanceCompareEnum = {
  Equal: '1',
  Greater: '2',
  Less: '3'
};

export const CategorySendMessageType = {
  None: '',
  Signage: 'SignageMessage',
  Obc: 'ObcMessage',
  Location: 'LocationMessage',
  Message: 'Message'
};
